<template>
    <div class="empty-tabs-card">
        <div class="empty-tabs-card__header">
            <h3 class="empty-tabs-card__header-title">{{ cardTitle }}</h3>
        </div>
        <div class="empty-tabs-card__body">
            <div class="empty-tabs-card__empty">
                <img class="empty-tabs-card__empty-img" :src="emptyImgLink" />
                <div class="empty-tabs-card__empty-text">
                    <div class="empty-tabs-card__empty-oops">Oops!</div>
                    <div
                        class="empty-tabs-card__empty-warning"
                        v-html="emptyText"
                    />
                </div>
            </div>
        </div>
        <div class="empty-tabs-card__footer">
            <div
                v-if="!noAction"
                class="empty-tabs-card__footer-link-wrapper btn-link"
                @click="toFullLink"
            >
                {{ buttonText }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        emptyImgLink: {
            type: String,
            default: '',
        },
        emptyText: {
            type: String,
            default: '',
        },
        cardTitle: {
            type: String,
            default: '',
        },
        toFullRouter: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: 'Подобрать',
        },
        noAction: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        toFullLink() {
            window.location = this.toFullRouter;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.empty-tabs-card {
    background: #ffffff;
    box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);
    border-radius: mrem(10);
    padding: mrem(20);
    margin-bottom: mrem(20);

    @include on-desktop {
        box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);
        border-radius: rem(10);
        padding: rem(30);
        margin-bottom: rem(30);
        min-height: rem(190);
    }

    &__empty {
        display: flex;
        align-items: center;
        padding-left: mrem(22);
        margin-top: 10px;

        @include on-desktop {
            justify-content: left;
            padding-left: rem(200);
            margin-top: rem(-35);
        }

        &-img {
            width: mrem(85);
            height: mrem(81);

            @include on-desktop {
                width: rem(85);
                height: rem(81);
            }
        }

        &-text {
            font-style: normal;
            font-weight: normal;
            font-size: mrem(14);
            line-height: mrem(22);
            margin-left: mrem(24);
            color: #9fb7e3;

            @media (min-width: 450px) {
                margin-left: rem(24);
                font-size: rem(16);
                line-height: rem(22);
            }
        }

        &-oops {
            font-weight: 600;
        }
        &-warning {
            font-weight: 400;
            max-width: mrem(270);
            @include on-desktop {
                max-width: rem(270);
            }
        }
    }

    &__body {
        position: relative;
    }

    &__header {
        display: flex;
        margin: mrem(0) mrem(0) mrem(16) mrem(0);

        @include on-desktop {
            margin: rem(0) rem(0) rem(16) rem(0);
        }

        &-title {
            font-style: normal;
            font-weight: 600;
            font-size: mrem(22);
            line-height: mrem(32);
            display: flex;
            align-items: center;
            color: #2a2626;
            flex: none;
            order: 0;
            flex-grow: 0;
            margin: mrem(0);

            @include on-desktop {
                font-size: rem(20);
                line-height: rem(32);
                margin: rem(0) rem(0) rem(25) rem(0);
                font-weight: 700;
            }
        }
    }

    &__footer {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: mrem(18);
        line-height: mrem(26);
        color: #4663ab;

        @include on-desktop {
            justify-content: flex-end;
            font-size: rem(18);
            line-height: rem(26);
        }

        &-link {
            display: inline-block;

            &-wrapper {
                @include on-desktop {
                    border: 1px solid transparent;
                    cursor: pointer;

                    &:hover {
                        border-bottom: 1px solid #4663ab;
                    }
                }
            }
        }
    }
}
.btn-link {
    display: inline;
    font-size: mrem(14);
    line-height: mrem(26);
    text-align: center;
    margin-top: mrem(16);
    color: #ffffff;
    padding: mrem(10) mrem(16);
    width: 100%;
    height: mrem(46);
    background: #4663ab;
    border-radius: mrem(10);
    font-weight: 600;

    @include on-desktop {
        margin-top: 0;
        font-size: rem(14);
        line-height: rem(26);
        padding: rem(10) rem(16);
        width: auto;
        height: rem(48);
        border-radius: rem(10);
    }
}
</style>
